// PostMedia.js
import { connect } from 'react-redux';

import getAssetData from '../selector/getAssetData.js';
import getMessageData from '../selector/getMessageData.js';
import getOperationData from '../selector/getOperationData.js';
import PostMedia from '../component/PostMedia.jsx';
import { push } from '../action/navigationAction.js';
import addMessage from '../action/addMessage.js';
import setPostMediaIntersectingData from '../action/setPostMediaIntersectingData.js';
import setMediaHeightInPostFeed from '../action/setMediaHeightInPostFeed.js';
import getIsMatchedPathname from '../resource/getIsMatchedPathname.js';
import withRouter from '../component/WithRouter.jsx';

import getMessageThumbnail from '../selector/getMessageThumbnail.js';
import { MediaAssetFormat } from '../resource/getMediaAsset.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getCurrentEngine from '../selector/getCurrentEngine.js';
import {
  POST_DETAIL_THUMBNAIL_SIZE,
  PREVIEW_PRESET,
} from '../RemoteConfigKeys.js';

const mapStateToProps = (state, { postId, location }) => {
  const activeAssetId = getMessageData(state, postId, 'activeAssetId');
  const activeAssetMediaType = getAssetData(
    state,
    [activeAssetId],
    'contentType'
  );
  const isActiveAssetVideoType = activeAssetMediaType?.startsWith('video');
  const thumbnailSize = getRemoteConfigData(state, POST_DETAIL_THUMBNAIL_SIZE);
  const isPreviewClear = getRemoteConfigData(state, PREVIEW_PRESET) === 'clear';

  const thumbnail = getMessageThumbnail(
    state,
    postId,
    '',
    `${thumbnailSize}x${thumbnailSize}`,
    MediaAssetFormat.JPG,
    isPreviewClear ? '' : 'blurred'
  );
  return {
    isPlayerSeeking: getOperationData(state, ['player'], 'isSeeking'),
    assetIds: getMessageData(state, postId, 'assetIds'),
    activeAssetId,
    isOnPostDetail: getIsMatchedPathname({
      pathname: location?.pathname,
      dataKey: 'isOnPostDetail',
    }),
    mediaHeightInPostFeed: getMessageData(
      state,
      postId,
      'mediaHeightInPostFeed'
    ),
    isActiveAssetVideoType,
    thumbnail,
    thumbnailSize,
    currentEngine: getCurrentEngine(state),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    push: (...args) => dispatch(push(...args)),
    setPostMediaIntersectingData: data =>
      dispatch(setPostMediaIntersectingData(data)),
    setMediaHeightInPostFeed: ({
      messageId,
      imageElement,
      mediaWrapperElement,
    }) =>
      dispatch(
        setMediaHeightInPostFeed({
          messageId,
          imageElement,
          mediaWrapperElement,
        })
      ),
    setPostActiveAssetId: ({ postId, activeAssetId }) =>
      dispatch(
        addMessage({
          message: {
            id: postId,
            activeAssetId,
          },
        })
      ),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PostMedia)
);
